// extracted by mini-css-extract-plugin
export var divider = "_3k-0";
export var dividerText = "_3k-1";